import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, Cards, Checkbox, Form, FormField, Input, Link, SegmentedControl, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemCounter } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';

export const ConfigCountersPage = () => {
  //const storeAdmin = useStoreAdmin();
  const [counter, setCounter] = useState<ItemCounter | null>(null);
  const { menu, data } = useGlobalState();

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");
      if (id)
        handleGetCounter(parseInt(id));
      else {
        setCounter(null);
      }
      //handleGetEmail(id ? parseInt(id) : 0);
      //else
      //setMailTemplate(undefined);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  useEffect(() => {

  }, []);


  const handleUpdateCounter = async () => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/counters/update',
        },
        body: JSON.stringify(counter),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0 && dataWeb.counters) {
        setData((prevData: any) => ({
          ...prevData,        // Keep all other properties (e.g., users, statuses, airports)
          counters: dataWeb.counters // Overwrite only the counters array
        }));

        window.location.hash = "#config/counters";
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };
  const handleGetCounter = async (id: number) => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/counters/get',
        },
        body: JSON.stringify({ idCounter: id }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setCounter(dataWeb.counter);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };

  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>{`Contadores ${counter ? counter.counter : ''}`}</Header>
          {counter && (
            <Form actions={
              <SpaceBetween size="m" direction='horizontal'>
                <Button variant="link" onClick={() => { window.location.hash = "#config/counters"; }}>Cancelar</Button>
                <Button variant="primary" onClick={() => {
                  handleUpdateCounter();
                }}>Actualizar</Button>
              </SpaceBetween>}>

              <SpaceBetween size="m" direction='vertical'>
                <div style={{ width: 200 }}>
                  <FormField label="Número de puerta">
                    <Input value={counter.counter} onChange={e => {
                      setCounter({ ...counter!, counter: e.detail.value });
                    }} />
                  </FormField>
                </div>
                <SegmentedControl selectedId={counter.hub} onChange={e => {
                  setCounter({ ...counter!, hub: e.detail.selectedId });
                }}
                  options={[
                    { id: "NAC", text: "Nacional" },
                    { id: "INT", text: "Internacional" },
                    { id: "BOTH", text: "Ambos" },
                  ]}
                />
                <Checkbox checked={counter.isActiveCounter === 1} onChange={e => {
                  setCounter({ ...counter!, isActiveCounter: e.detail.checked ? 1 : 0 });
                }}>Activo</Checkbox>
                <div style={{ width: 200 }}>
                  <FormField label="TAG RMS" constraintText="ID utilizado en el sistema RMS">
                    <Input value={counter.AODBTAG} onChange={e => {
                      setCounter({ ...counter!, AODBTAG: e.detail.value });
                    }} />
                  </FormField>
                </div>
              </SpaceBetween>
            </Form>
          )}
          {!counter && (
            <Cards
              key="counters-cards"
              cardDefinition={{
                header: item => (
                  <Link href={`#config/counters?id=${item.idCounter}`} fontSize="heading-m">Counter {item.counter}</Link>
                ),
                sections: [
                  {
                    id: "idCounter",
                    header: "ID",
                    content: item => item.idCounter,
                    width: 50
                  },
                  {
                    id: "isActive",
                    header: "Estado",
                    content: item => item.isActiveCounter === 1 ? <StatusIndicator type="success">Activo</StatusIndicator> : <StatusIndicator type="error">Inactivo</StatusIndicator>,
                    width: 50
                  },
                  {
                    id: "hub",
                    header: "Función",
                    content: item => item.hub === "BOTH" ? "Nacional e internacional" : item.hub === "NAC" ? "Nacional" : "Internacional",
                  },
                ]
              }}
              cardsPerRow={[
                { cards: 1 },
                { minWidth: 500, cards: 3 }
              ]}
              items={(data.counters || []) as ItemCounter[]}
              trackBy="idCounter"
            />
          )}
        </SpaceBetween>
      }
    />
  )
};
